var render = function render(){var _vm=this,_c=_vm._self._c;return _c('div',{class:{
    'font-weight-medium full-width bottom black': true,
    'small-letter-spacing': true,
    'text-xs': _vm.$vuetify.breakpoint.smAndDown,
    'text-md': _vm.$vuetify.breakpoint.mdAndUp,
  }},[_c('span',[_c('span',{staticClass:"red--text font-weight-bold"},[_vm._v("*")]),_vm._v("Montant calculé, sans apport initial, sur la base d'un remboursement mensuel d'une durée de "+_vm._s(_vm.loyer_duration)+" mois avec un taux annuel effectif global de "+_vm._s(parseFloat((_vm.loyer_taeg * 100).toFixed(10)))+"%. Le montant indiqué est à titre d'exemple et peut ne pas correspondre à la réalité. Pour plus d'information, contacter un commercial. ")])])
}
var staticRenderFns = []

export { render, staticRenderFns }